import {Slot, Switch, Text, Trail, Typography} from '@logistics-frontend/blocks'
import React from 'react'

import {Controller, useFormContext} from '../../externalPackage'
import {SwitchRequirementModel} from '../types'
import {classes} from './SwitchRequirement.classes'

type Props = {
  name: string
  requirement: SwitchRequirementModel
  onChange?: (value?: boolean) => void
}

export function SwitchRequirement({name, requirement, onChange}: Props): React.ReactElement {
  const {control} = useFormContext()

  return (
    <Controller
      control={control}
      defaultValue={requirement.defaultValue}
      name={name}
      render={({field, fieldState}) => {
        return (
          <Slot size="l">
            <Text className={classes.body}>
              <Typography thickness="regular" variant="body2">
                {requirement.title}
              </Typography>
              {requirement.description && (
                <Typography color="minor" variant="caption1">
                  {requirement.description}
                </Typography>
              )}
            </Text>
            <Trail>
              <Switch
                error={fieldState.invalid}
                name={name}
                on={field.value}
                onChange={function _onChange(on) {
                  field.onChange(on)
                  onChange?.(on)
                }}
                size="m"
              />
            </Trail>
          </Slot>
        )
      }}
      rules={{
        required: requirement.required,
      }}
    />
  )
}
